import { ActivatedRoute } from '@angular/router';
import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import { Angulartics2 } from 'angulartics2';

import { AuthService } from 'app/user/auth.service';
import { camelCase } from 'app/core/case-transform';
import { validate } from 'app/user/form.functions';

interface UserLogin {
    email: string;
    password: string;
}

interface LoginQueryParams {
    returnUrl: string;
}

@Component({
    selector: 'login',
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.scss']
})
export class LoginComponent {

    error: string;

    processing: boolean;

    user: UserLogin = { email: '', password: '' };

    constructor(private _angulartics2: Angulartics2,
        private _activatedRoute: ActivatedRoute,
        private _authService: AuthService,
        private _router: Router) {
    }

    validate(form: NgForm) {
        validate(form);
    }

    onHideError(): void {
        this.error = null;
    }

    onSubmit(form: NgForm) {
        if (form.valid) {
            this.error = null;
            this.processing = true;
            this._authService.login(this.user.email, this.user.password).subscribe(
                () => this._onSuccess(),
                (response) => this._onError(response)
            );
        }
    }

    private _onSuccess(): void {
        this._angulartics2.setUsername.next(this.user.email);
        this._angulartics2.eventTrack.next({
            action: 'Login',
            properties: {
                eventType: 'click'
            }
        });
        this._angulartics2.eventTrack.next({
            action: 'SignInSuccess',
            properties: {
                event: 'SignInSuccess'
            }
        });
        this._activatedRoute.queryParams.subscribe((params: LoginQueryParams) => {
            return this._router.navigateByUrl(params.returnUrl || '/');
        });
    }

    private _onError(response): void {
        if (response.status === 400) {
            this.error = camelCase(response.json().error);
        }
        this.processing = false;
    }

}
